import React, { useState, useEffect } from "react";
import {
    Container,
    Row,
    Col,
    Card,
    Form,
    Button,
    Spinner,
    InputGroup
} from "react-bootstrap";
import { Icon } from "semantic-ui-react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Login = () => {

    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [pwd, setPwd] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [remember, setRemember] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        if (email === "") {
            alert("Email harus diisi");
            return;
        }
        if (pwd === "") {
            alert("Password harus diisi");
            return;
        }
        setLoading(true);
        try {
            const res = await axios.post(
                `${global.srv}pos-app/controler/pos.php?i=7`,
                {
                    email,
                    pwd
                }
            );

            if (res.data.status === 200) {
                localStorage.setItem(
                    "pos_session",
                    JSON.stringify({
                        user: res.data.user,
                        loginTime: Date.now()
                    })
                );

                if (remember) {
                    localStorage.setItem(
                        "remember_login",
                        JSON.stringify({
                            remember: true,
                            email: email
                        })
                    );
                    window.location.reload()
                } else {
                    localStorage.removeItem("remember_login");
                }
                navigate("/pos");
            } else {
                alert(res.data.msg)
            }
        } catch (err) {
            console.log(err);
            alert("Login gagal.");
        }
        setLoading(false);
    };

    const logout = () => {
        localStorage.removeItem("pos_user");
        navigate("/login");
    };

    useEffect(() => {
        const session = JSON.parse(localStorage.getItem("pos_session"));
        if (!session) return;
        const SESSION_TIMEOUT = 30 * 60 * 1000;
        const expired =
            Date.now() - session.loginTime > SESSION_TIMEOUT;
        if (expired) {
            localStorage.removeItem("pos_session");
        } else {
            navigate("/pos");
        }
    }, [navigate]);

    useEffect(() => {
        const rememberLogin = JSON.parse(
            localStorage.getItem("remember_login")
        );
        if (rememberLogin) {
            setEmail(rememberLogin.email);
            setRemember(true);
        }
    }, []);

    return (

        <div
            style={{
                minHeight: "100vh",
                background:
                    "linear-gradient(135deg,#0f766e,#14b8a6,#ecfeff)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >

            <Container>

                <Row className="justify-content-center">

                    <Col lg={5} md={7}>

                        <Card
                            className="shadow-lg border-0"
                            style={{
                                borderRadius: 20
                            }}
                        >

                            <Card.Body
                                style={{
                                    padding: 40
                                }}
                            >

                                <div
                                    className="text-center mb-4"
                                >

                                    <div
                                        style={{
                                            width: 90,
                                            height: 90,
                                            margin: "auto",
                                            borderRadius: "50%",
                                            background: "#14b8a6",
                                            color: "#fff",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: 36
                                        }}
                                    >

                                        <Icon name="shopping cart" />

                                    </div>

                                    <h2
                                        className="mt-3 fw-bold"
                                    >
                                        POS Print Station
                                    </h2>

                                    <div
                                        className="text-muted"
                                    >
                                        Manage transactions and print receipts instantly.
                                    </div>

                                </div>

                                <Form
                                    onSubmit={handleLogin}
                                >

                                    <Form.Group
                                        className="mb-3"
                                    >

                                        <Form.Label>
                                            Email
                                        </Form.Label>

                                        <InputGroup>

                                            <InputGroup.Text>

                                                <Icon name="mail" />

                                            </InputGroup.Text>

                                            <Form.Control
                                                placeholder="Email"
                                                value={email}
                                                onChange={(e) =>
                                                    setEmail(
                                                        e.target.value
                                                    )
                                                }
                                            />

                                        </InputGroup>

                                    </Form.Group>

                                    <Form.Group
                                        className="mb-3"
                                    >

                                        <Form.Label>
                                            Password
                                        </Form.Label>

                                        <InputGroup>

                                            <InputGroup.Text>

                                                <Icon name="lock" />

                                            </InputGroup.Text>

                                            <Form.Control
                                                type={
                                                    showPassword
                                                        ? "text"
                                                        : "password"
                                                }
                                                placeholder="Password"
                                                value={pwd}
                                                onChange={(e) =>
                                                    setPwd(
                                                        e.target.value
                                                    )
                                                }
                                            />

                                            <Button
                                                variant="outline-secondary"
                                                onClick={() =>
                                                    setShowPassword(
                                                        !showPassword
                                                    )
                                                }
                                            >

                                                <Icon
                                                    name={
                                                        showPassword
                                                            ? "eye slash"
                                                            : "eye"
                                                    }
                                                />

                                            </Button>

                                        </InputGroup>

                                    </Form.Group>

                                    <Form.Check
                                        className="mb-4"
                                        label="Remember me"
                                        checked={remember}
                                        onChange={(e) =>
                                            setRemember(
                                                e.target.checked
                                            )
                                        }
                                    />

                                    <Button
                                        type="submit"
                                        className="w-100"
                                        style={{
                                            height: 50,
                                            fontWeight: 600,
                                            borderRadius: 12,
                                            background: "#0f766e",
                                            border: 0
                                        }}
                                        disabled={loading}
                                    >

                                        {
                                            loading ?

                                                <>

                                                    <Spinner
                                                        animation="border"
                                                        size="sm"
                                                        className="me-2"
                                                    />

                                                    Signing In...

                                                </>

                                                :

                                                <>

                                                    <Icon
                                                        name="sign in"
                                                    />

                                                    Login

                                                </>

                                        }

                                    </Button>

                                </Form>

                                <hr />

                                <div
                                    className="text-center text-muted"
                                >

                                    POS Print System

                                    <br />

                                    Version 2.0

                                </div>

                            </Card.Body>

                        </Card>

                    </Col>

                </Row>

            </Container>

        </div>

    );

};

export default Login;